import { render, staticRenderFns } from "./EditorPlayer.vue?vue&type=template&id=46132507"
import script from "./EditorPlayer.vue?vue&type=script&lang=js"
export * from "./EditorPlayer.vue?vue&type=script&lang=js"
import style0 from "./EditorPlayer.vue?vue&type=style&index=0&id=46132507&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports